// extracted by mini-css-extract-plugin
module.exports = {"windowSection":"InvestmentCard_windowSection__2n7oy"};